import React from "react";
import "../App.css"
import img2 from "../images/img-2.png"
import JoinButton from "./JoinButton";
import Navbar from "./Navbar";


function Banner() {
    return (

        <div className="bannerBg">
            <div className="container pt-4">
                <Navbar />
                <div className="freeSpaceForBanner"></div>
                <div className="row">

                    <div className="col-md-6 artaxia">
                        <h3><span>Artaxia</span> offers an ideal destination for both art enthusiasts and investors alike.</h3>
                        <p> Our collection of hand-drawn artwork boasts exceptional quality and is available at a mint price of
                            0.01 ETH. With only 1,143 pieces available, we aim to provide a unique and exclusive experience for
                            our esteemed community.
                        </p>
                        <p>We are committed to ensuring that our community members can benefit from their investments by taking
                            in 0 royalties initially. Additionally, we host weekly ETH/NFT giveaways on our community Discord,
                            providing our members with even more opportunities to engage with and enjoy our artwork.</p>
                        <div className="btn121 pt-5">
                            <JoinButton
                                text="Join Our Discord"
                            />
                        </div>
                    </div>

                    {/* <div className="col-md-1"></div> */}

                    <div className="col-md-5 ">
                        <img className="w-100 bannerimg ml-5 " src={img2}></img>
                    </div>
                    {/* </div> */}
                </div>
            </div>
        </div>
    )
}

export default Banner;